import { Link } from 'react-router-dom';
import TooltipWrapper from '../tooltip/TooltipWrapper';
import { Routes } from '@/types';

interface WorkspaceNameProps {
  workspaceName: string;
  workspaceId?: string;
  projectTitle: string;
  organizationId?: string;
  resetTabs: () => void;
  routes: Routes;
}

function WorkspaceName({
  projectTitle,
  workspaceName,
  routes,
  organizationId,
  workspaceId,
  resetTabs,
}: WorkspaceNameProps) {
  return (
    <div className="flex items-center gap-1 group">
      <span className="text-neutral-300">/</span>
      <div className="flex items-center gap-1 max-w-0 overflow-hidden opacity-0 group-hover:max-w-[200px] group-hover:opacity-100 transition-all duration-200 ease-in-out">
        <TooltipWrapper text="Back to workspace" className="text-xs">
          <Link
            onClick={resetTabs}
            className="text-neutral-400 hover:text-neutral-700 hover:underline transition-colors truncate max-w-[180px]"
            to={`${routes.organization.path}/${organizationId}${routes.workspace.path}/${workspaceId}`}
          >
            {workspaceName}
          </Link>
        </TooltipWrapper>
        <span className="text-neutral-300">/</span>
      </div>
      <p className="truncate max-w-[300px]">{projectTitle}</p>
    </div>
  );
}

export default WorkspaceName;
